import { render, staticRenderFns } from "./CustomFieldTemplateTableHeaders.vue?vue&type=template&id=1d98c4b6&scoped=true"
import script from "./CustomFieldTemplateTableHeaders.vue?vue&type=script&lang=js"
export * from "./CustomFieldTemplateTableHeaders.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldTemplateTableHeaders.vue?vue&type=style&index=0&id=1d98c4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98c4b6",
  null
  
)

export default component.exports